function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M23.2663 9.67353L13.5971 0.572008C12.7923 -0.18561 11.3757 -0.195712 10.5601 0.572008L0.901722 9.66343C0.0646605 10.4514 0.0646605 11.7242 0.901722 12.5121L10.5601 21.6035C10.9787 21.9975 11.526 22.1894 12.0733 22.1894C12.6206 22.1894 13.1679 21.9975 13.5864 21.6035L23.2341 12.5222C24.0819 11.7545 24.0926 10.4817 23.2663 9.67353ZM12.084 20.1792L2.4256 11.0878L12.084 1.99633L21.7424 11.0878L12.084 20.1792ZM7.78065 10.0877V14.1283H9.92696V11.0979H14.2196V13.6232L17.9756 10.0877L14.2196 6.55214V9.07754H8.8538C8.26357 9.07754 7.78065 9.53211 7.78065 10.0877Z",
  fill: "white"
});

var SvgDirectionsWhite = function SvgDirectionsWhite(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 23,
    viewBox: "0 0 24 23",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDirectionsWhite, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/directions-white.b2e12d42.svg";
export { ForwardRef as ReactComponent };